import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="payment-cancel-page">
      <h1 className="font-serif text-4xl font-bold">Payment cancelled</h1>
      <p className="mt-4 text-slate-600">No money was taken. Your basket is still saved.</p>
      <Link to="/checkout" className="mt-8 inline-block rounded-full bg-[#8C2220] text-white px-7 py-3.5 font-semibold" data-testid="back-to-checkout">Back to checkout</Link>
    </div>
  );
}
